module.exports = __webpack_public_path__ + "img/k-blue-woman-front.3fb45e57.jpg";